/**
 * Sticky add-to-cart bar — scroll visibility, dropdown sync, price sync
 */
(function () {
  const root = document.getElementById('sticky_atc');
  if (!root) {
    return;
  }

  const sizeDropdown = root.querySelector('.sticky-atc__dropdown--size');
  const offerDropdown = root.querySelector('.sticky-atc__dropdown--offer');
  const priceEl = root.querySelector('.sticky-atc__price');
  const ctaBtn = root.querySelector('.sticky-atc__cta');
  const ctaLabels = {
    add: ctaBtn?.dataset.addLabel || 'ADD TO CART',
    notify: ctaBtn?.dataset.notifyLabel || 'NOTIFY ME',
  };

  function closeAllDropdowns() {
    root.querySelectorAll('.sticky-atc__dropdown.is-open').forEach((dropdown) => {
      dropdown.classList.remove('is-open');
    });
  }

  function toggleDropdown(dropdown) {
    if (!dropdown || dropdown.classList.contains('is-hidden')) {
      return;
    }

    const isOpen = dropdown.classList.contains('is-open');
    closeAllDropdowns();

    if (!isOpen) {
      dropdown.classList.add('is-open');
    }
  }

  function setTriggerContent(dropdown, title, subtitle) {
    const titleEl = dropdown.querySelector('.sticky-atc__trigger-title');
    const subtitleEl = dropdown.querySelector('.sticky-atc__trigger-subtitle');

    if (titleEl) {
      titleEl.textContent = title || '';
    }

    if (subtitleEl) {
      if (subtitle) {
        subtitleEl.textContent = subtitle;
        subtitleEl.hidden = false;
      } else {
        subtitleEl.textContent = '';
        subtitleEl.hidden = true;
      }
    }
  }

  function syncStickyPrice() {
    if (!priceEl) {
      return;
    }

    const checkoutPrice = document.querySelector('.cta_checkout_price');
    const pillPrice = document.querySelector('.pill_price');
    const actualPrice = document.querySelector('.new_price_holder .actual_new_price');
    // Custom PDPs update price on [final-sale-price]; prefer the main price block.
    const customSalePrice =
      document.querySelector('.main-product-prices .sale-price[final-sale-price="true"]') ||
      document.querySelector('[data-block="price"] [final-sale-price="true"]') ||
      document.querySelector('[data-block="summary-block"] [final-sale-price="true"]');

    if (pillPrice && pillPrice.textContent.trim()) {
      priceEl.textContent = pillPrice.textContent.trim();
      return;
    }

    if (checkoutPrice && checkoutPrice.textContent.trim()) {
      priceEl.textContent = checkoutPrice.textContent.trim();
      return;
    }

    if (actualPrice && actualPrice.textContent.trim()) {
      priceEl.textContent = actualPrice.textContent.trim();
      return;
    }

    if (customSalePrice && customSalePrice.textContent.trim()) {
      priceEl.textContent = customSalePrice.textContent.trim();
    }
  }

  function syncSizeTriggerFromMain() {
    if (!sizeDropdown || sizeDropdown.classList.contains('is-hidden')) {
      return;
    }

    const selectedItem = document.querySelector('#content_bellow_p_title .item_list.selected');
    if (selectedItem) {
      const titleEl = selectedItem.querySelector('.right_partw_text');
      const sizeEl = selectedItem.querySelector('.right_partw_size');
      setTriggerContent(
        sizeDropdown,
        titleEl ? titleEl.textContent.trim() : '',
        sizeEl ? sizeEl.textContent.trim() : ''
      );
      return;
    }

    // Custom PDPs: mirror the variant picker selection by variant ID.
    const selectedVariantId = document.querySelector(
      "[data-block='variant-picker'] .selected-variant-option .variant-item[data-variant-id]"
    )?.dataset.variantId;
    const panelItem = selectedVariantId
      ? sizeDropdown.querySelector(`.sticky-atc__panel-item[data-variant-id="${selectedVariantId}"]`)
      : null;

    if (panelItem) {
      sizeDropdown.querySelectorAll('.sticky-atc__panel-item').forEach((item) => {
        item.classList.remove('is-selected');
      });
      panelItem.classList.add('is-selected');
      setTriggerContent(sizeDropdown, panelItem.dataset.title || '', panelItem.dataset.subtitle || '');
      return;
    }

    const selectedOption = sizeDropdown.querySelector('.sticky-atc__panel-item.is-selected');
    if (selectedOption) {
      setTriggerContent(
        sizeDropdown,
        selectedOption.dataset.title || '',
        selectedOption.dataset.subtitle || ''
      );
    }
  }

  function rebuildOfferDropdown() {
    if (!offerDropdown) {
      return;
    }

    const variantId = document.querySelector('#content_bellow_p_title .item_list.selected')?.getAttribute('v_id');
    const container = variantId
      ? document.querySelector(`#content_bellow_p_title .PDP_offer_data[data-variant-offer-id="${variantId}"]`)
      : null;
    const offerInfos = container
      ? Array.from(container.querySelectorAll('.offer_info')).filter((offerInfo) => {
        return Boolean(offerInfo.querySelector('.offer_title')?.textContent.trim());
      })
      : [];

    if (!container || offerInfos.length === 0) {
      offerDropdown.classList.add('is-hidden');
      return;
    }

    offerDropdown.classList.remove('is-hidden');
    const panel = offerDropdown.querySelector('.sticky-atc__panel');
    if (!panel) {
      return;
    }

    panel.innerHTML = '';

    offerInfos.forEach((offerInfo) => {
      const label = offerInfo.closest('label');
      const radio = label ? label.querySelector('input[type="radio"]') : null;
      const title = offerInfo.querySelector('.offer_title')?.textContent.trim() || '';
      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'sticky-atc__panel-item';
      button.dataset.radioId = radio ? radio.id : '';
      button.innerHTML = `<span class="sticky-atc__panel-title">${title}</span>`;

      if (radio && radio.checked) {
        button.classList.add('is-selected');
        setTriggerContent(offerDropdown, title, '');
      }

      button.addEventListener('click', () => {
        if (radio) {
          radio.checked = true;
          radio.dispatchEvent(new Event('change', { bubbles: true }));
        }

        offerInfo.click();
        panel.querySelectorAll('.sticky-atc__panel-item').forEach((item) => {
          item.classList.remove('is-selected');
        });
        button.classList.add('is-selected');
        setTriggerContent(offerDropdown, title, '');
        closeAllDropdowns();
        syncStickyPrice();
      });

      panel.appendChild(button);
    });

    if (!panel.querySelector('.sticky-atc__panel-item.is-selected') && panel.firstElementChild) {
      panel.firstElementChild.classList.add('is-selected');
      const title = panel.firstElementChild.querySelector('.sticky-atc__panel-title')?.textContent.trim() || '';
      setTriggerContent(offerDropdown, title, '');
    }
  }

  /**
   * Finds the custom variant picker entry for a variant ID.
   *
   * @param {String} variantId Variant ID to look up.
   * @returns {(Element|null)} Matching picker item.
   */
  function getCustomPickerItem(variantId) {
    if (!variantId) {
      return null;
    }

    return document.querySelector(
      `[data-block='variant-picker'] .variant-picker-options .variant-item[data-variant-id="${variantId}"]`
    );
  }

  function bindSizeDropdownItems() {
    if (!sizeDropdown) {
      return;
    }

    sizeDropdown.querySelectorAll('.sticky-atc__panel-item').forEach((item) => {
      item.addEventListener('click', () => {
        const varTitle = item.dataset.varTitle;
        if (varTitle) {
          const mainItem = document.querySelector(`#content_bellow_p_title .item_list[var_title="${CSS.escape(varTitle)}"]`);
          if (mainItem) {
            mainItem.click();
          } else {
            const legacyTrigger = document.querySelector(`[var_title="${varTitle}"]`);
            if (legacyTrigger) {
              legacyTrigger.click();
            } else {
              // Custom PDPs have no legacy picker, so drive the variant picker
              // entry that carries the same variant ID.
              const customItem = getCustomPickerItem(item.dataset.variantId);
              if (customItem) {
                customItem.click();
              }
            }
          }
        }

        sizeDropdown.querySelectorAll('.sticky-atc__panel-item').forEach((panelItem) => {
          panelItem.classList.remove('is-selected');
        });
        item.classList.add('is-selected');
        setTriggerContent(sizeDropdown, item.dataset.title || '', item.dataset.subtitle || '');
        closeAllDropdowns();
        rebuildOfferDropdown();
        syncStickyPrice();
        syncCtaState();
      });
    });
  }

  function bindPillowDropdownItems() {
    if (!sizeDropdown) {
      return;
    }

    sizeDropdown.querySelectorAll('.sticky-atc__panel-item[data-quantity]').forEach((item) => {
      item.addEventListener('click', () => {
        if (typeof window.select_pillow_quantity === 'function') {
          window.select_pillow_quantity(item);
        }

        sizeDropdown.querySelectorAll('.sticky-atc__panel-item').forEach((panelItem) => {
          panelItem.classList.remove('is-selected');
        });
        item.classList.add('is-selected');
        setTriggerContent(
          sizeDropdown,
          item.dataset.title || '',
          item.dataset.subtitle || ''
        );
        closeAllDropdowns();
        syncStickyPrice();
      });
    });
  }

  function getSubmitButton() {
    return document.querySelector(
      'product-form .product-form__buttons .product-form__submit:not(.bis-product-button)'
    );
  }

  function getCustomAtcButton() {
    return document.querySelector(
      "[data-block='summary-block'] .main-product-atc-button[stock]"
    );
  }

  function isVariantSoldOut() {
    // Custom PDPs expose availability through the stock attribute; they render
    // no <product-form> or variant-selects to read from.
    const customAtcButton = getCustomAtcButton();
    if (customAtcButton) {
      return customAtcButton.getAttribute('stock') === 'false';
    }

    // Prefer the in-memory selected variant (updated before ATC toggle) so we
    // do not flash Notify me off a temporarily disabled submit button.
    const variantSelects = document.querySelector('variant-selects, variant-radios');
    if (variantSelects?.currentVariant) {
      return !variantSelects.currentVariant.available;
    }

    const submitButton = getSubmitButton();
    return Boolean(submitButton && submitButton.hasAttribute('disabled'));
  }

  function triggerNotifyMe() {
    const bisTrigger = document.querySelector(
      '#BIS_trigger, button#BIS_trigger, .bis-product-button'
    );

    if (bisTrigger) {
      bisTrigger.click();
      return true;
    }

    // Custom PDPs have no AMP-injected trigger; reuse the shared opener that
    // drives AMP's generic BIS_trigger handler.
    if (typeof window.openBackInStockForm === 'function') {
      return window.openBackInStockForm();
    }

    return false;
  }

  function syncCtaState() {
    if (!ctaBtn) {
      return;
    }

    const soldOut = isVariantSoldOut();

    ctaBtn.classList.toggle('is-notify', soldOut);
    ctaBtn.classList.remove('is-disabled');
    ctaBtn.disabled = false;
    ctaBtn.textContent = soldOut ? ctaLabels.notify : ctaLabels.add;
    ctaBtn.setAttribute(
      'aria-label',
      soldOut ? ctaLabels.notify : ctaLabels.add
    );
  }

  function syncSizeFromVariantTitle(varTitle) {
    if (!sizeDropdown || sizeDropdown.classList.contains('is-hidden') || !varTitle) {
      return;
    }

    const escapedTitle = typeof CSS !== 'undefined' && CSS.escape
      ? CSS.escape(varTitle)
      : varTitle.replace(/"/g, '\\"');
    const item = sizeDropdown.querySelector(`.sticky-atc__panel-item[data-var-title="${escapedTitle}"]`);

    if (!item) {
      syncSizeTriggerFromMain();
      return;
    }

    sizeDropdown.querySelectorAll('.sticky-atc__panel-item').forEach((panelItem) => {
      panelItem.classList.remove('is-selected');
    });
    item.classList.add('is-selected');
    setTriggerContent(sizeDropdown, item.dataset.title || '', item.dataset.subtitle || '');
  }

  function isElementVisible(element) {
    let current = element;
  
    while (current) {
      if (current.hasAttribute('hidden')) {
        return false;
      }
  
      const style = window.getComputedStyle(current);
      if (style.display === 'none' || style.visibility === 'hidden') {
        return false;
      }
  
      current = current.parentElement;
    }
  
    return true;
  }
  
  function getElementOffsetTop(selector) {
    const elements = document.querySelectorAll(selector);
  
    for (const element of elements) {
      if (!isElementVisible(element)) {
        continue;
      }
  
      return element.getBoundingClientRect().top + window.scrollY;
    }
  
    return null;
  }

  function updateVisibility() {
    const buttonsTop = getElementOffsetTop('.product-form__buttons');
    const footerTop = getElementOffsetTop(
      '#shopify-section-footer_signup_new, #shopify-section-insta_feed, #shopify-section-footer_help_bar, .shopify-section-group-footer-group'
    );

    if (buttonsTop === null || footerTop === null) {
      return;
    }

    const shouldShow =
      window.scrollY - 50 > buttonsTop &&
      window.scrollY + window.innerHeight < footerTop;

    root.classList.toggle('is-visible', shouldShow);

    if (!shouldShow) {
      closeAllDropdowns();
    }
  }

  root.querySelectorAll('.sticky-atc__trigger').forEach((trigger) => {
    trigger.addEventListener('click', (event) => {
      event.stopPropagation();
      toggleDropdown(trigger.closest('.sticky-atc__dropdown'));
    });
  });

  if (ctaBtn) {
    ctaBtn.addEventListener('click', () => {
      if (ctaBtn.classList.contains('is-notify')) {
        if (!triggerNotifyMe()) {
          setTimeout(triggerNotifyMe, 300);
        }

        return;
      }

      const submitButton = getSubmitButton() || getCustomAtcButton();
      if (submitButton) {
        submitButton.click();
      }
    });
  }

  document.addEventListener('click', (event) => {
    if (!event.target.closest('#sticky_atc')) {
      closeAllDropdowns();
    }
  });

  window.addEventListener('scroll', updateVisibility, { passive: true });

  document.addEventListener('change', (event) => {
    if (event.target.matches('#content_bellow_p_title input[type="radio"][name="offer"]')) {
      rebuildOfferDropdown();
      syncStickyPrice();
    }
  });

  document.addEventListener('click', (event) => {
    if (event.target.closest('#content_bellow_p_title .item_list')) {
      setTimeout(() => {
        syncSizeTriggerFromMain();
        rebuildOfferDropdown();
        syncStickyPrice();
      }, 100);
    }

    if (event.target.closest("[data-block='variant-picker'] .variant-item")) {
      setTimeout(() => {
        syncSizeTriggerFromMain();
        syncStickyPrice();
        syncCtaState();
      }, 100);
    }

    if (event.target.closest('#content_bellow_p_title .offer_info')) {
      setTimeout(() => {
        rebuildOfferDropdown();
        syncStickyPrice();
      }, 100);
    }
  });

  bindSizeDropdownItems();
  bindPillowDropdownItems();
  syncSizeTriggerFromMain();
  rebuildOfferDropdown();
  syncStickyPrice();
  syncCtaState();
  updateVisibility();

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.variantChange, () => {
      setTimeout(syncCtaState, 0);
    });
  }

  const submitButton = getSubmitButton();
  if (submitButton && typeof MutationObserver !== 'undefined') {
    const observer = new MutationObserver(syncCtaState);
    observer.observe(submitButton, {
      attributes: true,
      attributeFilter: ['disabled'],
    });
  }

  setInterval(() => {
    syncStickyPrice();
    syncCtaState();
  }, 200);

  window.syncStickyAtcPrice = syncStickyPrice;
  window.rebuildStickyOfferDropdown = rebuildOfferDropdown;
  window.syncStickySizeFromVariantTitle = syncSizeFromVariantTitle;
})();
